import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

export interface CopyAdviceConfirmationDialogOutputModel {
  removeExistingTreatments: boolean;
}

export interface CopyAdviceConfirmationDialogData extends AbstractDialogData {
  text: string;
  askForRemoveExistingTreatmentsConfirmation: boolean;
}

@Component({
  selector: 'app-copy-advice-confirmation',
  templateUrl: './copy-advice-confirmation-dialog.component.html',
  styleUrls: ['./copy-advice-confirmation-dialog.component.scss'],
  standalone: false,
})
export class CopyAdviceConfirmationDialogComponent extends AbstractDialog<CopyAdviceConfirmationDialogOutputModel> {
  data = inject<CopyAdviceConfirmationDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef =
  inject<MatDialogRef<CopyAdviceConfirmationDialogComponent, AbstractDialogResultData<CopyAdviceConfirmationDialogOutputModel>>>(MatDialogRef);

  removeExistingTreatmentsChoice = false;

  prepareConfirm(radioGroupValue: boolean) {
    this.confirm({
      removeExistingTreatments: radioGroupValue,
    });
  }
}
